export default "/images/9b5461429494ffc281fe345e951368d1.avif";